/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, CardMedia, Checkbox, FormControlLabel, Grid, IconButton, Theme, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import { MFTextField, MFSubmitButton } from '../../lib/formik';
import React, { useEffect, useRef, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import MFCheckbox from '../../lib/formik/Checkbox';
import { DataMaster, DataMasters, dataTypeMasters, NomineeType } from '../../redux-store/types/api-types';
import {
  applicationComparison,
  applyRoleBasedStatus,
  getApplicantName,
  getNomineeRelation,
  getNomineeRelationship,
  getUniqueIdentityText,
  isMinor,
  isOnboardingTypeMinor,
  removeSingleQuote,
  saveForLater,
  sendRoleBasedStatus,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useRouteMatch } from 'react-router';
import { getDocuments, updateApplication } from '../../redux-store/actions/application';
// import { DatePicker } from '../../lib/formik/DatePicker';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { nomineeDetailsSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import { AMC_APPROVER_CHECK_FOR_INDIVIDUAL, idProofLabelsMasters, IdProofsMasters, NOMINEE_DETAILS_NOMINEE_LIMIT, NomineeRelations, restrictedRelation } from '../../utils/constant';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import { DeleteIconFilled } from '../../assets/SvgIcons';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
// import { getNationalityList } from '../../redux-store/actions';
import { getDataMasters } from '../../redux-store/actions/onBoarding';
import { showError } from '../../redux-store/actions/auth';
import { getFormattedISTDateString } from '../../utils/date';
import { initiateNomineeModification, initiateNomineeModificationBody, initiateNomineeModificationRes } from '../../redux-store/actions/nominee';
import { initialDocument } from '../JointHolder/CreateJointHolder';
import { FileUpload } from './documentDetails';
import UseRadioGroup from '../../lib/formik/Radio';

type updateNominee = NomineeType & {
  Relationship: string | null;
  sno?: number;
};

type Values = {
  doNotWishToNominate: boolean;
  nominees: updateNominee[];
  nomineesSOA: boolean | string | null;
  countryDropdown: string[];
  saveType: string;
  documents: initialDocument[];
};

const newNominee: updateNominee = {
  nomineeName: '',
  nomineeRelationship: '',
  dateOfBirth: null,
  nomineePercentage: 0,
  guardianName: '',
  // nomineePan: '',
  nomineeGuardianPan: '',
  isActive: true,
  Relationship: '',
  sno: 0,
  //added according to new requirements
  idProofType: '',
  idProofValue: '',
  mobile: '',
  countryNameAndCode: 'India: +91',
  countryCode: '+91',
  email: '',
  address1: '',
  address2: '',
  address3: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
  addressSameAsFirstNominee: false,
  addressSameAsApplicant: false,
};

const initialValues: Values = {
  doNotWishToNominate: true,
  nominees: [newNominee],
  nomineesSOA: null,
  countryDropdown: [],
  saveType: 'save and proceed',
  documents: [
    // {
    //   documentId: "",
    //   documentType: "nominee_opt_out",
    //   documentName: "Nominee Opt out Declaration",
    //   multipleFiles: "",
    //   required: 'false',
    //   options: [],
    //   uploadFormats: [
    //   ],
    //   maxFiles: 1,
    //   maxFileSize: "1MB",
    //   minFileSize: "",
    //   disabled: false,
    //   isActive: true,
    //   uniqueKey: ''
    // }
  ]


};

const Nominee = ({
  nomineeName,
  index,
  values,
  // mdmsCountriesList,
  dataMasters,
  dataMasterLoading,
  indexValue
}: {
  nomineeName: number;
  index: number;
  values: Values;
  // mdmsCountriesList: mdmsCountriesList[];
  dataMasters: DataMaster;
  dataMasterLoading?: boolean;
  indexValue: number
}): JSX.Element => {
  const { dateOfBirth = '' } = values.nominees[index];
  const { setFieldValue } = useFormikContext();
  const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)
  const [mobileElementWidth, setMobileElementWidth] = useState(null);

  const {
    RELATIONSHIP = [],
    COUNTRY = [],
    STATE = [],
    CITY = [],
  } = dataMasters || {};

  useEffect(() => {
    const mobileElement = document.getElementsByName('nominees.0.countryNameAndCode');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);

  return (
    <>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.nomineeName`}
          label={`Enter Nominee Name ${nomineeName}*`}
          placeholder={`Enter Nominee Name ${nomineeName}`}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`nominees.${index}.Relationship`}
          label="Select Nominee Relationship*"
          items={RELATIONSHIP.filter((val: dataTypeMasters) => {
            const { nominees } = values;
            const selectedRelations = nominees
              .filter(
                (nominee, ind) =>
                  ind !== index &&
                  nominee.Relationship &&
                  nominee.isActive &&
                  restrictedRelation.includes(`${nominee.Relationship ?? ''}`.toLowerCase())
              )
              .map((nominee) => `${nominee.Relationship ?? ''}`.toLowerCase());
            return !selectedRelations.includes(`${val?.description ?? ''}`.toLowerCase());
          }).map((val: dataTypeMasters) => ({
            key: val?.description,
            value: val?.description,
          }))}
          isCapitalize
          disabled={dataMasterLoading}
          loading={dataMasterLoading}

        />
      </Grid>
      {values.nominees.map((nominee, idx: number) => {
        if (`${nominee.Relationship ?? ''}`.toLowerCase() === 'others' && idx === index) {
          return (
            <Grid item xs={12} lg={6} key={idx}>
              <MFTextField
                name={`nominees.${index}.nomineeRelationship`}
                label="Please Specify Relationship*"
                placeholder={`Enter Nominee Relationship`}
              />
            </Grid>
          );
        }
      })}
      <Grid item xs={12} lg={6}>
        <TextDatePicker
          label={'Date of Birth *'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Date of Birth'}
          name={`nominees.${index}.dateOfBirth`}
          minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.nomineePercentage`}
          label="Nominee % *"
          placeholder="Enter Nominee %"
          onKeyDown={(e) => {
            if (['-', '+'].includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
      </Grid>
      {/* <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.nomineePan`}
          label={`Enter Nominee ${getUniqueIdentityText(company)?.pan}`}
          placeholder={`Enter Nominee ${getUniqueIdentityText(company)?.pan}`}
          inputProps={{ style: { textTransform: 'uppercase' } }}
          onChange={(e) => {
            setFieldValue(`nominees.${index}.nomineePan`, e.target.value.toUpperCase());
          }}
        />
      </Grid> */}
      {isMinor(dateOfBirth ? dateOfBirth : '') && (
        <>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.guardianName`}
              label="Enter Guardian Name*"
              placeholder="Enter Guardian Name"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.nomineeGuardianPan`}
              label={`Enter Guardian ${getUniqueIdentityText(company)?.pan}*`}
              placeholder="Enter Guardian Pan"
              inputProps={{ style: { textTransform: 'uppercase' } }}
              onChange={(e) => {
                setFieldValue(`nominees.${index}.nomineeGuardianPan`, e.target.value.toUpperCase());
              }}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        <SubHeading
          sx={{
            letterSpacing: '0.02px',
          }}>
          Address & Contact Details
        </SubHeading>
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`nominees.${index}.idProofType`}
          label={`Any one of the id proof*`}
          items={IdProofsMasters?.map(proof => ({ key: proof, value: proof }))}
          onChange={(e) => {
            setFieldValue(`nominees.${index}.idProofType`, e.target.value);
            setFieldValue(`nominees.${index}.idProofValue`, '');
          }}
        />
      </Grid>
      {values.nominees[index].idProofType && (
        <Grid item xs={12} lg={6}>
          <MFTextField
            name={`nominees.${index}.idProofValue`}
            label={idProofLabelsMasters[values.nominees[index].idProofType as string]}
            placeholder={idProofLabelsMasters[values.nominees[index].idProofType as string]}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            type={values.nominees[index].idProofType === 'Aadhaar Card' ? 'number' : 'text'}
            onChange={(e) => {
              if (values.nominees[index].idProofType === 'Aadhaar Card' && e.target.value.length > 4) {
                setFieldValue(`nominees.${index}.idProofValue`, e.target.value.slice(0, 4));
              } else {
                setFieldValue(`nominees.${index}.idProofValue`, e.target.value.toUpperCase());
              }
            }}
          />
        </Grid>
      )}
      {!values.nominees[index].idProofType && (
        <Grid item xs={12} lg={6} sx={{ height: '100%' }}></Grid>
      )}
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.mobile`}
          label={`Mobile*`}
          placeholder="Mobile"
          type='number'
          startAdornment={
            <CountryCodesDropDown
              ElementWidth={mobileElementWidth && mobileElementWidth}
              name={`nominees.${index}.countryNameAndCode`}
              value={values.nominees[index].countryNameAndCode}
            />
          }

        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`nominees.${index}.email`}
          label={`Email*`}
          placeholder="Email"
        />
      </Grid>
      <Grid item xs={12}>
        <MFCheckbox
          name={`nominees.${index}.addressSameAsApplicant`}
          label="Address Same as Applicant"
          onChange={(e) => {
            setFieldValue(`nominees.${index}.addressSameAsApplicant`, e.target.checked);
          }}
        />
      </Grid>
      {/* {indexValue !== 0 && values.nominees.filter((item) => item.isActive).length > 1 &&
        <Grid item xs={12}>
          <MFCheckbox
            name={`nominees.${index}.addressSameAsFirstNominee`}
            label="Address Same as First Nominee"
          />
        </Grid>} */}
      {(!values?.nominees[index]?.addressSameAsApplicant) && (
        <>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.address1`}
              label={`Address Line 1*`}
              placeholder="Address Line 1"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.address2`}
              label={`Address Line 2`}
              placeholder="Address Line 2"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.address3`}
              label={`Address Line 3`}
              placeholder="Address Line 3"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`nominees.${index}.pincode`}
              label={`PIN Code*`}
              placeholder="PIN Code"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <SearchableSelect
              name={`nominees.${index}.city`}
              label="City*"
              items={CITY?.map((val: any) => ({
                key: val?.description,
                value: val?.description,
              }))}
              searchFieldPlaceholder={'Search City'}
              disabled={dataMasterLoading}
              loading={dataMasterLoading}
            />
          </Grid>
          {`${values.nominees[index]?.city ?? ''}`.toLowerCase() === 'others' && (
            <Grid item xs={12} lg={6}>
              <MFTextField
                name={`nominees.${index}.otherCity`}
                label={`Enter City*`}
                placeholder="Enter Other City"
              />
            </Grid>
          )}
          <Grid item xs={12} lg={6}>
            <SearchableSelect
              name={`nominees.${index}.state`}
              label="State*"
              items={STATE?.map((val: any) => ({
                key: val?.description,
                value: val?.description,
              }))}
              searchFieldPlaceholder={'Search State'}
              disabled={dataMasterLoading}
              loading={dataMasterLoading}
            />
          </Grid>
          {`${values.nominees[index]?.state ?? ''}`.toLowerCase() === 'others' && (
            <Grid item xs={12} lg={6}>
              <MFTextField
                name={`nominees.${index}.otherState`}
                label={`Enter State*`}
                placeholder="Enter Other State"
              />
            </Grid>
          )}
          <Grid item xs={12} lg={6}>
            <SearchableSelect
              name={`nominees.${index}.country`}
              label="Country*"
              items={COUNTRY?.map((val: any) => ({
                key: val?.description,
                value: val?.description,
              }))}
              searchFieldPlaceholder={'Search Country'}
            />
          </Grid>
        </>
      )}

    </>
  );
};

export default function NomineeDetails({ isDirect = false, applicationId = '' }: { isDirect?: boolean; applicationId?: string; }): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [nomineesData, setNomineesData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [nomineeToDelete, setNomineeToDelete] = useState<{
    nominee: Partial<NomineeType>;
    index: number;
  } | null>(null);
  // const [nomineesToDelete, setNomineesToDelete] = useState<
  //   | {
  //       nominee: Partial<NomineeType>;
  //       // index: number;
  //     }[]
  //   | null
  // >(null);
  const [bulkNomineeDelete, setBulkNomineeDelete] = useState<boolean>(false);
  // const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [dataMasters, setDataMasters] = useState<DataMaster>({} as DataMaster);
  const [dataMasterLoading, setDataMasterLoading] = useState<boolean>(false);

  const [relationMaster, setRelationMaster] = useState<string[]>([])
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { path: currentPath } = useRouteMatch();
  // const [isShowErrPopup, setShowErrPopup] = useState<boolean>(false);
  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")
  const isShowErrPopup = useRef(false);
  const [documentUpload, setDocumentUpload] = useState<boolean>(false);
  const { applicationId: investorApplicationId = "", isBSEEnabled } = useSelector((state: RootStateType) => state.id);
  // const [documentsData, setDocumentsData] = useState<any>([]);

  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const nationalitiesMdmsMasters = (await dispatch(
  //         getNationalityList()
  //       )) as unknown as nationaliyType;
  //       setMdmsCountriesList(nationalitiesMdmsMasters.countries);
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, []);

  const isBSEEnabledFromResponse = isBSEEnabled ?? false; //took from redux

  const onSubmit = async (values: Values) => {
    isShowErrPopup.current = false;
    try {
      if (isDirect) {
        const {
          nominees: existingNominees = [],
          id: applicationId,
          clientCode,
          applicants = [],
          isMigrated = false,
        } = application || {};
        const { nominees, doNotWishToNominate } = values;

        // If user chose "I do not wish to nominate" require the opt-out declaration upload
        // if (doNotWishToNominate) {
        //   const doc = values.documents && values.documents.length ? values.documents[0] : null;
        //   const hasUpload = !!(doc && (doc.file || doc.documentId));
        //   if (!hasUpload) {
        //     dispatch(showError('Please upload nominee opt out declaration'));
        //     return;
        //   }
        // }
        if (nominees.length > 0) {
          const filteredNominees = nominees.filter((nominee) => nominee.isActive)
          const percentage = filteredNominees.reduce((acc, curr) => acc = acc + Number(curr.nomineePercentage), 0);
          if (percentage !== 100 && !doNotWishToNominate) {
            dispatch(showError('Total Nominee percentage should be 100%'));
            return;
          }
        }
        const updatedPayload = {
          doNotWishToNominate,
          nominees: nominees
            .filter((nominee) => nominee?.id || nominee.isActive)
            .map((nominee, index) => {
              const { id = null } = existingNominees[index] || {};
              if (nominee.id === id) {
                const { Relationship, sno, ...rest } = nominee;
                return {
                  ...(existingNominees[index] || {}),
                  ...rest,
                  applicationId,
                  countryCode: rest.countryNameAndCode?.split(':')[1].trim(),
                  nomineeRelationship: getNomineeRelationship(relationMaster, Relationship)
                    ? Relationship
                    : removeSingleQuote(nominee.nomineeRelationship),
                  dateOfBirth: !nominee.dateOfBirth
                    ? null
                    : new Date(nominee.dateOfBirth).toISOString(),
                  isActive: nominee.isActive && !doNotWishToNominate,
                  nomineeName: removeSingleQuote(rest.nomineeName),
                  guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.guardianName)
                    : null,
                  nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.nomineeGuardianPan)
                    : null,
                  addressSameAsApplicant: rest.addressSameAsApplicant ? true : false,
                };
              }
              const { Relationship, sno, ...rest1 } = nominees[nominee.sno as number];
              return {
                ...rest1,
                nomineeRelationship: getNomineeRelationship(relationMaster, Relationship)
                  ? Relationship
                  : removeSingleQuote(nominee.nomineeRelationship),
                // dateOfBirth: !nominee.dateOfBirth
                // ? null
                // : getFormattedISTDateString(nominee.dateOfBirth),
                nomineeName: removeSingleQuote(rest1.nomineeName),
                guardianName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.guardianName)
                  : null,
                nomineeGuardianPan: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.nomineeGuardianPan)
                  : null,
                addressSameAsApplicant: rest1.addressSameAsApplicant ? true : false,
                countryCode: rest1.countryNameAndCode?.split(':')[1].trim(),
                applicationId,
              };
            }),
          nomineesSOA: values?.doNotWishToNominate ? null : values?.nomineesSOA ?? null,
          clientCode: clientCode ?? '',
          isMigrated: isMigrated ?? false,
          // documents: values?.documents?.map(doc => ({
          //   ...doc,
          //   applicantId: applicants[0]?.id ?? ''
          // })) || []
        };

        try {
          setLoading(true);
          const res = await (dispatch(initiateNomineeModification(updatedPayload))) as unknown as initiateNomineeModificationRes;
          if (!res) {
            return
          };
          if (res?.isSuccess) {
            history.push(`/nominee/otp-screen`, {
              id: res?.id ?? "",
              cartId: res?.cartId ?? "",
              message: res?.message ?? "",
              token: res?.token ?? "",
              nomineesSOA: res?.nomineesSOA ?? null
            });
          }
        } catch (e) {
          dispatch(showError("Please Try Again"))
        } finally {
          setLoading(false);

        }

      }
      else {
        const {
          nominees: existingNominees = [],
          id,
          applicant1ReferenceId = '',
          currentStep,
          status,
          hasPOA,
          applicationNumber,
        } = application || {};
        const { nominees, doNotWishToNominate, saveType } = values;
        if (nominees.length > 0) {
          const filteredNominees = nominees.filter((nominee) => nominee.isActive)
          const percentage = filteredNominees.reduce((acc, curr) => acc = acc + Number(curr.nomineePercentage), 0);
          if (percentage !== 100 && !doNotWishToNominate) {
            dispatch(showError('Total Nominee percentage should be 100%'));
            return;
          }
        }
        const updatedPayload = {
          ...application,
          doNotWishToNominate,
          nominees: nominees
            .filter((nominee) => nominee?.id || nominee.isActive)
            .map((nominee, index) => {
              const { id = null } = existingNominees[index] || {};
              if (nominee.id === id) {
                const { Relationship, sno, ...rest } = nominee;
                return {
                  ...(existingNominees[index] || {}),
                  ...rest,
                  nomineeRelationship: getNomineeRelationship(relationMaster, Relationship)
                    ? Relationship
                    : removeSingleQuote(nominee.nomineeRelationship),
                  dateOfBirth: !nominee.dateOfBirth
                    ? null
                    : getFormattedISTDateString(nominee.dateOfBirth),
                  isActive: nominee.isActive && !doNotWishToNominate,
                  nomineeName: rest.nomineeName,
                  guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? rest.guardianName
                    : '',
                  nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                    ? removeSingleQuote(rest.nomineeGuardianPan)
                    : null,
                  countryCode: rest.countryNameAndCode?.split(':')[1].trim(),
                };
              }
              const { Relationship, sno, ...rest1 } = nominees[nominee.sno as number];
              return {
                ...rest1,
                nomineeRelationship: removeSingleQuote(rest1.nomineeRelationship),
                nomineeName: rest1.nomineeName,
                guardianName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? rest1.guardianName
                  : '',
                nomineeGuardianPan: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                  ? removeSingleQuote(rest1.nomineeGuardianPan)
                  : null,
                countryCode: rest1.countryNameAndCode?.split(':')[1].trim(),
              };
            }),
          nomineesSOA: values?.doNotWishToNominate ? null : values?.nomineesSOA ?? null,
        };
        const checkApplication = applicationComparison(
          {
            ...application,
            nominees: application?.nominees?.sort(
              (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
            ),
          },
          {
            ...updatedPayload,
            nominees: updatedPayload.nominees?.sort(
              (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
            ),
            currentStep: !!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
          }
        );
        const isSaveLater = saveType !== 'save and proceed';
        if (id && !checkApplication) {
          setLoading(true);
          const response = await dispatch(
            updateApplication({
              body: {
                ...updatedPayload,
                // status:
                //   !hasPOA &&
                //     AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                //     status !== 'draft' &&
                //     applyRoleBasedStatus(role)
                //     ? 'sent_to_amc_approver'
                //     : status,
                status: sendRoleBasedStatus(role, status as string),
                currentStep: 6,
                //!!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
              },
              applicationId: id,
              ...(isSaveLater && { toastMessage: '' }),
            })
          );
          if (!response) {
            setLoading(false);
            return;
          }
          !isSaveLater
            ? history.push('fatca', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
        } else if (checkApplication) {
          if (isSaveLater) {
            enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
              variant: 'success',
              autoHideDuration: 3000,
            });
          }
          !isSaveLater
            ? history.push('fatca', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
        }
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async function () {
      try {
        const { nominees = [], doNotWishToNominate = true, onboardingType = '', nomineesSOA } = application || {};
        const nomineesList = nominees.length > 0 ? nominees : isOnboardingTypeMinor(onboardingType) ? [] : [];
        setDataMasterLoading(true);
        let relationMaster: string[] = [];
        const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
        if (res?.data) {
          setDataMasterLoading(false);
          setDataMasters(res?.data ?? {});
          relationMaster = (res?.data?.RELATIONSHIP || []).map((item) => item?.description);
          setRelationMaster(relationMaster);

        }
        // if (isDirect) {
        //   const response = await dispatch(getDocuments() as unknown as any)
        //   setDocumentsData((response[application?.applicationType ?? ""] ?? [])?.find((item: any) => item.documentType === "nominee_opt_out"));
        // }
        setNomineesData({
          ...nomineesData,
          doNotWishToNominate: isOnboardingTypeMinor(onboardingType)
            ? true
            : nomineesList.length
              ? false
              : doNotWishToNominate === null
                ? true
                : doNotWishToNominate,
          nominees: nomineesList.length
            ? nomineesList.map((nominee, index) => ({
              ...nominee,
              Relationship: getNomineeRelationship(relationMaster, nominee.nomineeRelationship)
                ? nominee.nomineeRelationship
                  ? nominee.nomineeRelationship
                  : nominee.nomineeRelationship
                : 'Others',
              nomineeRelationship: getNomineeRelationship(relationMaster, nominee.nomineeRelationship)
                ? ''
                : nominee.nomineeRelationship,
              sno: index,
              nomineePercentage: nominee.nomineePercentage
                ? nominee.nomineePercentage
                : nomineesList.length === 1
                  ? 100
                  : 0,
              countryNameAndCode: nominee.countryNameAndCode
                ? nominee.countryNameAndCode
                : 'India: +91',
              countryCode: nominee.countryCode ? nominee.countryCode : '+91',
            }))
            : [],
          nomineesSOA: doNotWishToNominate ? null : `${nomineesSOA ?? ""}`
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const { onboardingType = '' } = application || {};

  const handleDocumentUploadStart = () => {
    setDocumentUpload(true);
  };
  const handleDocumentUploadEnd = () => {
    setDocumentUpload(false);
  };

  return (
    <Formik
      initialValues={nomineesData}
      onSubmit={onSubmit}
      enableReinitialize={true}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, nomineeDetailsSchema(application?.applicants, currencyCode, company), true, values);
        } catch (e) {
          if (isShowErrPopup.current) {
            dispatch(showError(`Please fill all required fields.`));
            isShowErrPopup.current = false;
            // const nominees = values?.nominees || [];
            // const total = nominees
            //   .filter((_nominee: NomineeType) => _nominee.isActive)
            //   .map((nominee: NomineeType) => Number(nominee.nomineePercentage))
            //   .reduce((a: number, b: number) => a + b, 0);
            // const isAll100Per = nominees.length && total === 100;
            // if (isAll100Per) {
            //   dispatch(showError(`Please fill all required fields`));
            // } else {
            //   dispatch(showError('Total Nominee % should be equal to 100-%'));
            // }
          }
          return yupToFormErrors(e);
        }
      }}>
      {({ handleSubmit, values, setValues, dirty }) => {
        const nomineePercentage = values
          ?.nominees
          ?.filter((_nominee) => _nominee.isActive)
          ?.reduce((acc, curr) => acc = acc + Number(curr.nomineePercentage), 0)

        return (
          <Grid
            container
            // rowSpacing={1}
            // columnSpacing={5}
            columnSpacing={3}
            rowSpacing={0.5}
            // sx={{
            //   width: '100%',
            //   ml: 0,
            //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            // }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <Grid item xs={12} my={2}>
              <Notes displayContent={`${isOnboardingTypeMinor(onboardingType) ? ' Note:- Nominee is not required for Minor Investor.' : 'Investor(s) have the option to choose upto three nominees.'}`} />
            </Grid>
            <Grid item xs={12} my={2}>
              <Box sx={{ width: "fit-content" }}>
                <MFCheckbox
                  disabled={isOnboardingTypeMinor(onboardingType)}
                  name="doNotWishToNominate"
                  label="I do not wish to nominate."
                  sx={{ letterSpacing: '1px' }}
                  onChange={({ target: { checked } }) => {
                    const updatedNominees = !checked
                      ? [
                        ...values.nominees,
                        { ...newNominee, nomineePercentage: 100, sno: values.nominees.length },
                      ]
                      : values.nominees;
                    setValues({
                      ...nomineesData,
                      doNotWishToNominate:
                        values.nominees?.filter((item) => item.isActive).length === 0
                          ? checked
                          : !checked,
                      nominees: updatedNominees.map((nominee) => ({
                        ...nominee,
                      })),
                      nomineesSOA: values.nomineesSOA
                    });
                    checked && setBulkNomineeDelete(true);
                  }}
                  checked={values.doNotWishToNominate}
                />
              </Box>
            </Grid>
            {values.nominees
              .filter((_nominee) => _nominee.isActive)
              .map((nominee, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={12}>
                    <SubHeading
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                      }}>
                      <Typography variant='body_500' color="primary.900">
                        {getApplicantName(index + 1, true)} Nominee Details
                      </Typography>
                      {/* <Box
                        sx={{ display: 'flex', alignItems: 'center' }}
                        onClick={() => setNomineeToDelete({ nominee, index: nominee.sno as number })}>
                        <Typography
                          sx={{
                            color: 'rgba(196, 42, 51, 0.8)',
                            fontSize: 12,
                            ml: 'auto',
                            letterSpacing: '-0.2px',
                            cursor: 'pointer',
                          }}>
                          Remove Nominee{' '}
                        </Typography>
                        <IconButton sx={{ p: '2px' }}>
                          <CardMedia
                            component="img"
                            src="/images/delete-red.svg"
                            alt="Delete Icon"
                            sx={{ width: 'unset' }}
                          />
                        </IconButton>
                      </Box> */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "primary.100",
                          borderRadius: "50%",
                          padding: "5px",
                          cursor: "pointer"
                        }}
                        onClick={() => {
                          setNomineeToDelete({ nominee, index: nominee.sno as number });
                          if (index == 0) {
                            setValues(prevValues => {
                              const updatedNominees = prevValues.nominees.map((nominee, i) => {
                                if (i !== index) {
                                  return { ...nominee, addressSameAsFirstNominee: false };
                                }
                                return nominee;
                              });
                              return { ...prevValues, nominees: updatedNominees };
                            });
                          }
                        }}
                      >
                        <DeleteIconFilled />
                      </Box>
                    </SubHeading>
                  </Grid>
                  <Nominee
                    nomineeName={index + 1}
                    index={nominee.sno as number}
                    key={nominee.sno as number}
                    // mdmsCountriesList={mdmsCountriesList}
                    values={values}
                    dataMasters={dataMasters}
                    dataMasterLoading={dataMasterLoading}
                    indexValue={index}
                  />
                  <Grid item xs={12} my={1} />
                </React.Fragment>
              ))}
            {values.nominees.filter((item) => item.isActive).length < NOMINEE_DETAILS_NOMINEE_LIMIT && (
              <Grid item xs={12}>
                <Button
                  // variant="contained"
                  variant='outlined'
                  startIcon={<AddIcon sx={{
                    color: (isOnboardingTypeMinor(onboardingType)) ? 'grey.500' : 'primary.500'
                  }} />}
                  sx={(theme: Theme) => ({
                    // color: 'common.white',
                    // fontWeight: 500,
                    // fontSize: 14,
                    // mt: 2,
                    // mx: 1,
                    backgroundColor: `${theme.palette.primary[500]}1A`,
                    border: `1px solid ${theme.palette.primary[500]}`,
                    ...theme.typography.body_500,
                    color: theme.palette.primary[500],
                    padding: "10px 15px",
                    '&.Mui-disabled': {
                      backgroundColor: theme.palette.textDark.disabled
                    }
                  })}
                  disabled={isOnboardingTypeMinor(onboardingType)}
                  onClick={() =>
                    setValues({
                      ...values,
                      nominees: [
                        ...values.nominees,
                        {
                          ...newNominee,
                          nomineePercentage: values.nominees.filter((item) => item.isActive).length
                            ? 0
                            : 100,
                          sno: values.nominees.length,
                          addressSameAsApplicant: false,
                          addressSameAsFirstNominee: false,
                        },
                      ],
                      doNotWishToNominate: false,
                    })
                  }>
                  Add Nominee
                </Button>
              </Grid>
            )}
            {/* {isDirect && values.doNotWishToNominate && !isOnboardingTypeMinor(onboardingType) && (
              <Grid item xs={12} sx={{ border: `1px solid #E0E0E0`, borderRadius: '10px', display: { xs: 'column', md: 'flex' }, padding: '20px', mt: 2, ml: 3 }}>
                <Grid item xs={12} md={6} mt={2}>
                  <Typography variant="body_500" sx={{ color: 'text.primary', mb: 2 }}>
                    {values.doNotWishToNominate ? `${documentsData?.documentName || 'Nominee Opt Out Declaration'}*` : 'Nominee Declaration Document*'}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} mt={2}>
                  <FileUpload
                    onFileChange={(value, documentId, removeFile) => {
                      const { file, ...rest } = values.documents[0];
                      setValues({
                        ...values,
                        documents: [
                          {
                            ...rest,
                            documentId,
                            ...(!removeFile && { file }),
                          }
                        ]
                      });
                    }}
                    name="documents.0.documentId"
                    documentData={{
                      ...values.documents[0],
                      required: 'true'
                    }}
                    disabled={false}
                    fileUploadFormats={documentsData?.uploadFormats}
                    maxUploadFiles={documentsData?.maxFiles}
                    maxFileSize={documentsData?.maxFileSize}
                    minFileSize={documentsData?.minFileSize}
                    multipleFilesCheck={documentsData?.multipleFiles}
                    onFileUpload={handleDocumentUploadStart}
                    onFileUploaded={handleDocumentUploadEnd}
                  />
                </Grid>
              </Grid>
            )} */}

            {!values.doNotWishToNominate && <Grid item xs={12} mt={2}>
              {/* <MFCheckbox
                name="nomineesSOA"
                label="Display Nominees in SOA"
                checked={values.nomineesSOA}
              /> */}
              <UseRadioGroup
                formLabel="Display Nominees in SOA*"
                name="nomineesSOA"
                items={[
                  { label: 'Yes', value: "true" },
                  { label: 'No', value: "false" },
                ]}
                value={values.nomineesSOA ?? ""}
              />
            </Grid>}
            <Grid item xs={12} my={2} />
            {
              isDirect ? (
                <Grid item xs={12}
                  sx={(theme: Theme) => ({
                    [theme.breakpoints.down('sm')]: {
                      mt: "-14px"
                    }
                  })}>
                  <MFSubmitButton
                    fullWidth
                    label={isBSEEnabledFromResponse ? "Submit to BSE" : "Submit"}
                    loadingEnable={loading}
                    disabled={!dirty}
                  />
                </Grid>

              ) : (
                <ProceedSaveLater
                  saveLater={() => {
                    isShowErrPopup.current = true;
                    setValues({
                      ...values,
                      nominees: values.nominees.map((nominee) => ({
                        ...nominee,
                        nomineeRelationship:
                          `${nominee.Relationship ?? ''}`.toLowerCase() === 'others'
                            ? nominee.nomineeRelationship
                            : nominee.Relationship,
                      })),
                      saveType: 'save for later',
                    });
                  }}
                  saveAndProceed={() => {
                    isShowErrPopup.current = true;
                    setValues({
                      ...values,
                      nominees: values.nominees.map((nominee) => ({
                        ...nominee,
                        nomineeRelationship:
                          `${nominee.Relationship ?? ''}`.toLowerCase() === 'others'
                            ? nominee.nomineeRelationship
                            : nominee?.Relationship,
                      })),
                      saveType: 'save and proceed',
                    });
                  }}
                  loader={loading}
                  clickedButton={values.saveType}
                  saveButtonText="Continue"
                  showEndIcon={false}
                />
              )
            }
            <ConfirmationDialog
              showIcon
              // message={'Are you sure you want to delete nominee(s) ?'}
              message="Deleting nominee details"
              subMessage="Are you sure you want to delete the nominee details? "
              open={nomineeToDelete !== null || bulkNomineeDelete !== false}
              setOpen={() => {
                setBulkNomineeDelete(false);
                setNomineeToDelete(null);
              }}
              onSave={async () => {
                try {
                  const { id } = application || {};
                  const remainedApplicants = values.nominees.map((nominee, i) => {
                    if (nominee.sno === nomineeToDelete?.index || bulkNomineeDelete) {
                      return {
                        ...nominee,
                        isActive: false,
                      };
                    }
                    return nominee;
                  });
                  setValues({
                    ...values,
                    nominees: remainedApplicants,
                    doNotWishToNominate:
                      remainedApplicants.filter((item) => item.isActive).length === 0
                        ? true
                        : values.doNotWishToNominate,
                    nomineesSOA: remainedApplicants.filter((item) => item.isActive).length === 0 ? null : values.nomineesSOA
                  });
                  setBulkNomineeDelete(false);
                  setNomineeToDelete(null);
                } catch (e) {
                  console.error((e as Error).message);
                }
              }}
              onCancel={() => {
                setBulkNomineeDelete(false);
                setNomineeToDelete(null);
              }}
            />
          </Grid>
        )
      }}
    </Formik>
  );
}
